var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-linear',{attrs:{"color":"green","height":"15","value":_vm.getProgress,"striped":""}},[_c('strong',{staticClass:"grey--text text--darken-2"},[_vm._v(_vm._s(_vm.$t('delivery.states.'+_vm.order.state)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }